/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SysqueSelectBoxModule } from '../../../../../../shared/ui/src/lib/components/sysque-select-box';
import { SelectSystemComponent } from './select-system.component';

@NgModule({
  declarations: [SelectSystemComponent],
  imports: [CommonModule, FormsModule, SysqueSelectBoxModule],
  exports: [SelectSystemComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SelectSystemModule {}
